import type { ValidationSearchParams } from '../../../api/types.js';
import {
  useAsyncValidationState,
  useDataFilePreview,
  usePlatformsCatalog,
  useTableDataFileTotalErrorsCount,
  useTableDataFileValidatedRows,
} from '../../../queries/index.js';

export const useValidatedData = (
  dataFileId: string,
  searchParams: ValidationSearchParams,
  options: { enabled: boolean },
) => {
  const { data: dataFilePreview } = useDataFilePreview(dataFileId);

  const isValidationStep = dataFilePreview.currentStep === 'validation';
  const isValidating =
    isValidationStep && dataFilePreview.status === 'validating';

  const isReady = options.enabled && isValidationStep && !isValidating;

  const totalErrorsCountQuery = useTableDataFileTotalErrorsCount(dataFileId, {
    enabled: isReady,
    throwOnError: true,
  });

  const validatedRowsQuery = useTableDataFileValidatedRows(
    dataFileId,
    searchParams,
    { enabled: isReady, throwOnError: true },
  );

  const validationState = useAsyncValidationState(dataFileId);

  const { isPending: platformsIsLoading } = usePlatformsCatalog();

  const totalErrorsCountData = totalErrorsCountQuery.data;

  return {
    ...validatedRowsQuery,
    isValidating,
    validationState,
    dataFilePreview,
    validatedRows: validatedRowsQuery.data,
    errorsCount: totalErrorsCountData?.totalErrors,
    nativeMetricsBanner: totalErrorsCountData?.nativeMetricsBanner ?? null,
    hasImportableData: totalErrorsCountData?.hasImportableData ?? true,
    isLoading:
      isValidating ||
      platformsIsLoading ||
      totalErrorsCountQuery.isLoading ||
      validatedRowsQuery.isLoading,
  };
};
